import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_FLOW } from 'flow-doctor-lib/queries/FlowQueries';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FlowNameLabel = ({
  portalId,
  flowId
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(GET_FLOW, {
    variables: {
      portalId,
      flowId
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.references.flow.unknownFlow",
        options: {
          flowId
        }
      })
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return /*#__PURE__*/_jsx("span", {
    children: data.fetchFlow.name
  });
};
export default FlowNameLabel;